export const EPagesMobileTabs = {
  AUTH_EMAIL: 'auth_email',
  AUTH_SOCIAL: 'auth_social',

  SETTINGS_NAVIGATION: 'settings_user_navigation',
  SETTINGS_PARAMS: 'settings_user_params',

  SEARCH_SETTINGS: 'search_settings',
  COLLECTION_LIST: 'collection_list',
  GRID2D: 'grid2d',

  USER_TASKS_LIST: 'user_tasks_list',
  USER_TASKS_HISTORY: 'user_tasks_history',
  USER_TASKS_GRID2D: 'user_tasks_grid2d',
  USER_TASKS_GENERATION_GRID2D: 'user_tasks_generation_grid2d',
};
